import { CONST } from '@/utils/constants'
import utils from '@/utils'
import { Modes } from '@/utils/enums'
export const extractTitle = (data) => data.GridDefinition.Title[0]
export const extractSubtitle = (data) => data.GridDefinition.Title[1]
export const extractTotal = (data) => data.Total
export const extractDirty = (data) => data.GridDefinition.Dirty
export const extractStyles = (data) => data.GridDefinition.Styles

// Returns an array of column header values
// These are html strings which are needed by flexgrid column headers
const extractColumnHeaderValues = (data) => {
  return data.GridDefinition.Header.Cells.map(header => header.Title.trim() === '' ? ' ' : header.Title.trim().split('\n').join('<br>'))
}

const extractColumnStyles = (data) => {
  return data.GridDefinition.ColumnStyles.reduce((accumulator, colStyle) => {
    accumulator[colStyle.UniqueId] = { width: colStyle.Width }
    return accumulator
  }, {})
}

const mergeColumnStyles = (column, allColumnStyles) => {
  return column.Styles.reduce((accumulator, style) => ({ ...accumulator, ...allColumnStyles[style] }), {})
}

const bufferColumnWidth = (width) => {
  return width === 0 ? 0 : (width * CONST.Grid.ColumnWidthMultiplier) + CONST.Grid.ColumnWidthBuffer
}

export const extractCells = (columns, data) => {
  const allCells = []
  data.Results.forEach((row, rowIndex) => {
    row.Cells.forEach(cell => {
      allCells[rowIndex] = {}
      columns.forEach((column, columnIndex) => {
        allCells[rowIndex][column.key] = row.Cells[columnIndex].Value
      })
    })
  })
  return allCells
}

export const extractColumns = (data) => {
  const allColumnStyles = extractColumnStyles(data)
  const columnmHeaders = extractColumnHeaderValues(data)
  return data.GridDefinition.Columns.map((column, index) => {
    const mergedStyle = mergeColumnStyles(column, allColumnStyles)
    const visible = mergedStyle.width !== 0
    const minWidth = bufferColumnWidth(mergedStyle.width)
    const width = visible ? minWidth + '*' : 0
    return {
      key: `col${index}`,
      value: columnmHeaders[index],
      visible,
      minWidth,
      width
    }
  })
}

export const extractCellsMetaData = (columns, data) => {
  const metadata = []
  data.Results.forEach((row, index) => {
    row.Cells.forEach(cell => {
      metadata[index] = []
      columns.forEach((column, columnIndex) => {
        metadata[index][columnIndex] = {
          cellType: row.Cells[columnIndex].CellType,
          styles: row.Cells[columnIndex].Styles
        }
      })
    })
  })
  return metadata
}
export const extractIsInReadOnlyMode = (data) => utils.isNullOrUndefined(data.GridDefinition) || !data.GridDefinition.IsBudgeting
export const extractIsInEditMode = (data) => !extractIsInReadOnlyMode(data)
export const extractMode = (data) => extractIsInReadOnlyMode(data) ? Modes.ReadOnly : Modes.Edit

export const extractCanInsert = (data) => data.GridDefinition.CanInsert
export const extractIsGridDefinitionNull = (data) => utils.isNullOrUndefined(data.GridDefinition)

export const extractColumnHeaderStyles = (data) => {
  return data.GridDefinition.Header.Cells.map((column, index) => ({
    'UniqueId': `header-col${index}`,
    'TextTransform': column.Style.TextTransform,
    'HorizontalAlignment': column.Style.HorizontalAlignment,
    'VerticalAlignment': column.Style.VerticalAlignment
  }))
}

export default {
  extractTitle,
  extractSubtitle,
  extractCells,
  extractCellsMetaData,
  extractTotal,
  extractIsInEditMode,
  extractIsInReadOnlyMode,
  extractIsGridDefinitionNull,
  extractCanInsert,
  extractColumns,
  extractDirty,
  extractColumnHeaderStyles,
  extractMode
}
